<script>import { createEventDispatcher } from "svelte";
import { SortStates, SortStatesEnum } from "../../index.js";
export let defaultState = SortStatesEnum.Descending;
$: activeState = defaultState;
$: upArrow = activeState === SortStatesEnum.Ascending || activeState === SortStatesEnum.Neutral;
$: downArrow = activeState === SortStatesEnum.Descending || activeState === SortStatesEnum.Neutral;
const dispatch = createEventDispatcher();
const toogleSort = () => {
  activeState = SortStates[activeState].nextState;
  dispatch("toggleNext", {
    activeState
  });
};
</script>

<div class="cursor-pointer">
  <button on:click={toogleSort}>
     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.83341 12.5L10.0001 16.6666L14.1667 12.5" stroke={upArrow ? "#CFCFCF" : "#5C656D"} stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.1666 7.50004L9.99992 3.33337L5.83325 7.50004" stroke={downArrow ? "#CFCFCF" : "#6C757D"} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</div>
